import script from "./ProgramsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramsSection.vue?vue&type=script&setup=true&lang=js"

import "./ProgramsSection.vue?vue&type=style&index=0&id=95b4c7ac&lang=scss"

const __exports__ = script;

export default __exports__